import styled from 'styled-components';

export const AddToCartButtonFilled = styled.div`
  &.add_btn_filled {
    border-radius: 2px;
    padding-top: 5px;
    background: ${(props) =>
      props.disabled ? 'rgb(219, 219, 219)' : '#ef4e5e'};
    color: ${(props) =>
      props.disabled ? 'rgba(155, 155, 155, 0.87)' : '#fff'};
    border: ${(props) =>
      props.disabled ? '1px solid rgb(219, 219, 219)' : '1px solid #ef4e5e'};
    height: 50px;
    line-height: 42px;
    margin: auto auto 0;
    display: block;
    width: 100%;
    position: relative;
    overflow: hidden;
    font-size: 16px;
    font-weight: 600;
    text-align: center;
    transition: all 0.1s ease-in-out 0s;
    @media (min-width: 720px) {
      cursor: pointer;
    }
  }
`;
